import { QueryClient } from '@tanstack/react-query';

/**
 * Singleton QueryClient — single source of truth for all React Query config.
 * Import this in App.tsx and any test setup instead of creating new instances.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,     // 5 minutes — reduces unnecessary refetches
      gcTime: 10 * 60 * 1000,       // 10 minutes — keep unused data in cache
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
